import React from 'react';
import { Link } from 'gatsby';

import SEO from '../../../components/seo';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';

import '../../../components/layout.css';

import sdg1 from '../../../images/kalinga/sdg-1.png';
import sdg2 from '../../../images/kalinga/sdg-2.png';
import sdg3 from '../../../images/kalinga/sdg-3.png';
import sdg7 from '../../../images/kalinga/sdg-7.png';
import sdg8 from '../../../images/kalinga/sdg-8.png';
import sdg12 from '../../../images/kalinga/sdg-12.png';
import sdg13 from '../../../images/kalinga/sdg-13.png';
import sdg15 from '../../../images/kalinga/sdg-15.png';

const sdgs = [
  { num: '1', title: 'No Poverty', img: sdg1 },
  { num: '2', title: 'Zero Hunger', img: sdg2 },
  { num: '3', title: 'Good Health', img: sdg3 },
  { num: '7', title: 'Clean Energy', img: sdg7 },
  { num: '8', title: 'Decent Work', img: sdg8 },
  { num: '12', title: 'Responsible Consumption', img: sdg12 },
  { num: '13', title: 'Climate Action', img: sdg13 },
  { num: '15', title: 'Life on Land', img: sdg15 },
];

const ImpactPage = () => (
  <div className="theme-default bg-background text-foreground">
    <SEO title="Impact" />
    <Header />

    <main>
      {/* OCF secondaryHero */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <span className="chip mb-6 inline-flex">Project Kalinga</span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light leading-tight tracking-tight mt-4">
            Impact
          </h1>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF twoUpLabelAndText: soil amendment */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 md:col-start-1">
              <span className="chip">Soil amendment</span>
            </div>
            <div className="md:col-span-8 md:col-start-5">
              <div className="prose prose-lg max-w-none">
                <p>
                  <strong>MatiBoost&#8482;</strong>, a biochar-enhanced soil
                  amendment product connecting durable carbon removal directly
                  with smallholder farm soil regeneration across Odisha.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF twoUpLabelAndText: SDG alignment */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 md:col-start-1">
              <span className="chip">SDG alignment</span>
            </div>
            <div className="md:col-span-8 md:col-start-5">
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {sdgs.map(({ num, title, img }) => (
                  <div
                    key={num}
                    className="bg-background-raised rounded border border-border p-4 text-center"
                  >
                    <img
                      src={img}
                      alt={`SDG ${num}`}
                      className="w-16 h-16 mx-auto mb-2 rounded"
                    />
                    <div className="font-mono text-xs text-muted-foreground">
                      SDG {num}
                    </div>
                    <div className="text-sm mt-1">{title}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF bottomCTA */}
      <section className="section theme-orange">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-7 md:col-start-6">
              <h2 className="text-3xl md:text-4xl font-light tracking-tight mb-6 leading-tight">
                Ready to explore Project Kalinga?
              </h2>
              <div className="flex flex-wrap gap-4">
                <Link to="/diligence" className="button-split group">
                  <span className="button-split-circle">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </span>
                  <span className="button-split-pill">
                    Request diligence access
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <Footer />
  </div>
);

export default ImpactPage;
